<template>
  <div class="examList">
    <div class="sub-box">
      <a @click="close" class="btn-return"> &lt; 返回</a>
      <div class="examlist-body">
        <!-- 广告位 -->
        <div class="ads" v-if="consultantAdv.image">
          <a v-if="consultantAdv.url !='#'" :href="consultantAdv.url">
            <img :src="consultantAdv.image" alt />
          </a>
          <img v-else :src="consultantAdv.image" alt />
        </div>
        <h2 v-if="type==1" class="list-tit"> {{cityName}} 分公司教育顾问</h2>
        <h2 v-else-if="type==2" class="list-tit"> {{cityName}} 分校考培顾问</h2>
        <h2 v-else-if="type==3" class="list-tit"> {{cityName}} 分公司学游顾问</h2>
        <div class="examlist-con">
          <ul class="countrylist" v-if="countryList.length>0">
            <li :class="{ active: item.id == countryId }" v-for="(item, index) in countryList" :key="index" @click="countryChage(item.id)">
              {{ item.name }}
            </li>
          </ul>
          <div class="examList-hid">
            <div class="exam-item" v-for="(item,index) in dataList" :key="index">
              <dl class="fix">
                <dt>
                  <img :src="item.head" alt />
                </dt>
                <dd>
                  <h5>{{item.name}}</h5>
                  <b v-if="type==1">服务项目：{{item.projectLine}}</b>
                  <b v-else-if="type==2">服务项目：出国考试培训</b>
                  <p class="ofw-hide-5">{{item.introduction}}</p>
                </dd>
              </dl>
            </div>

            <img class="loading" src="@/assets/images/loading.gif" v-if="loading" alt />
          </div>
        </div>
      </div>

    </div>

    <a class="btn-teacher-yy" @click="cikProjectShow">立即预约</a>

    <!-- 项目线弹窗 -->
    <div class="project-tc-bg" v-if="projectShow">
      <div class="project-tc">
        <span @click="projectShow = false">关闭</span>
        <ul>
          <li v-for="(item,index) in countryList" :key="index" @click="projectTips(index)" :class="{'active':item['check']}">{{item.name}}</li>
        </ul>
        <p>
          请选择您要咨询的项目顾问；
          <br />英爱：英国和爱尔兰，澳新：澳大利亚和新西兰
        </p>
        <button @click="appointment">确定</button>
      </div>
    </div>

    <Modal @appointment="appointment" @closeModal="modalType = -1" :type="modalType" :msg="modalmsg" :title="modaltitle" />
    <!-- 底部导航 -->
    <Footer style="margin-bottom:0" />
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" @closeLogin="isShowLogin = false" @success="loginSuccess" />
  </div>
</template>

<script>
import Login from "../components/login.vue";
import Footer from "../components/footer.vue";
import Modal from "@/components/modal.vue";
import {
  getAdv, //广告
  getExpoInfo, //活动信息
  userLoginStatus, //登录信息
  getAdviser, //顾问列表
  getCountry, //项目线
  getCityList, //分公司
  adviserSubscribe, //顾问预约
  getIpToCity, //IP定位
} from "@/api/home";
export default {
  components: { Footer, Login, Modal },
  data() {
    return {
      isLogin: false, //是否登录
      isShowLogin: false, //登录框是否展示
      modalType: -1,
      modalmsg: "",
      modaltitle: "",
      cityName: "", //城市名称
      cityList: [], //分公司列表
      consultantAdv: {
        image: "",
        url: "",
      }, // 顾问列表页广告
      expoId: 0, // 全局活动id
      status: 0, //预约时间状态
      loading: true, //列表加载框
      countryList: [], //项目线列表
      countryId: null, //数据项选中的项目线
      checkStr: "", //预约选择的项目线
      dataList: [],
      projectShow: false,
      type: null, //类型
    };
  },
  computed: {
    cityId: {
      get: function () {
        if (this.cityList.length > 0) {
          return this.cityList.filter((item) => item.name == this.cityName)[0]
            .id;
        }
        return [];
      },
    },
  },
  methods: {
    // 登录成功后触发
    loginSuccess() {
      // console.log("登录成功");
      this.isShowLogin = false;
      this.isLogin = true;
      this.appointment();
    },

    //获取分公司列表
    async getCityList() {
      let res = await getCityList({});
      if (res.succ) {
        this.cityList = res.results;
        if (this.type == 1) {
          this.getCountry(this.cityId);
        } else {
          this.getAdviser();
        }
      }
    },

    //获取项目线列表
    async getCountry(cityId) {
      let res = await getCountry({
        params: {
          cityId: cityId,
        },
      });
      if (res.succ) {
        for (let i = 0; i < res.results.length; i++) {
          res.results[i].check = false;
        }
        this.countryList = res.results;
        this.countryId = res.results[0].id;
        this.getAdviser();
      }
    },

    //获取顾问列表
    async getAdviser() {
      this.loading = true;
      let res = await getAdviser({
        params: {
          expoId: this.expoId,
          type: this.type,
          cityId: this.cityId,
          projectLineId: this.countryId,
          size: 100,
        },
      });
      if (res.succ) {
        this.dataList = res.results;
        this.loading = false;
      }
    },

    //项目线点击事件
    countryChage(id) {
      this.countryId = id;
      this.getAdviser();
    },

    // 打开项目线弹窗
    async cikProjectShow() {
      // 判断是否登陆
      if (!this.isLogin) {
        this.isShowLogin = true;
        return;
      }

      // 判断是否开始预约
      if (this.status == 1) {
        alert("11月1日才正式开始预约哦~");
        return;
      }

      if (this.status == 3) {
        alert("活动已结束~");
        return;
      }
      if (this.type == 1) {
        this.appointment();
      } else {
        this.projectShow = true;
      }
    },

    //选择项目线
    projectTips(idx) {
      let list = this.countryList;
      list[idx]["check"] = !list[idx]["check"];
      //console.log(list);
      var str = "";
      list.forEach((item) => {
        if (item["check"]) {
          str += item.name + ",";
        }
      });
      this.checkStr = str.substr(0, str.length - 1);
    },

    //留学顾问预约
    async appointment() {
      let res = await adviserSubscribe({
        expoId: this.expoId,
        typeId: [this.type],
        projectLineId: this.checkStr,
      });
      if (res.succ) {
        this.modalType = 1;
        this.modaltitle = "您已成功预约";
        this.modalmsg =
          "您已提交申请，<br>我们的工作人员会尽快与您联系，请保持电话畅通。";
      } else {
        this.modalType = 1;
        this.modaltitle = "提示";
        this.modalmsg = res.msg;
      }
    },

    // 考培和学游直接预约
    async appointment2() {
      let res = await adviserSubscribe({
        expoId: this.expoId,
        typeId: [this.type],
      });
      if (res.succ) {
        this.modalType = 1;
        this.modaltitle = "您已成功预约";
        this.modalmsg =
          "您已提交申请，<br>我们的工作人员会尽快与您联系，请保持电话畅通。";
      } else {
        this.modalType = 1;
        this.modaltitle = "提示";
        this.modalmsg = res.msg;
      }
    },

    // 获取活动expoId
    async getActivityInfo() {
      const res = await getExpoInfo({
        params: {
          name: "expo_science_engineering_202011_m",
        },
      });
      if (res.succ) {
        const { adviserSubscribeStatus, expoId } = res.results;
        this.status = adviserSubscribeStatus;
        this.expoId = Number(expoId);
      }
    },

    // 获取广告
    async getAdv() {
      const res = await getAdv({
        params: {
          expoId: this.expoId,
          city: this.cityName,
        },
      });
      console.log(res);
      if (res.succ) {
        this.consultantAdv =
          res.results.find((item) => item.tag == "yd_sub") || "";
      }
    },

    // 判断用户是否已经登录
    async userIsLogin() {
      let { succ } = await userLoginStatus();
      this.isLogin = succ;
    },

    //定位
    async getCurCity() {
      this.cityName = localStorage.getItem("cityName");
      if (!this.cityName) {
        let res = await getIpToCity();
        if (res.succ) {
          this.cityName = res.results;
          this.getAdviser();
        }
      }
      this.getAdv();
      this.getAdviser();
    },

    //返回
    close() {
      if (window.location.hostname == "m.eicchannel.com") {
        window.location.href =
          "http://m.eicchannel.com/special/expo_science_engineering_202011_m/#teacher";
      } else if (window.location.hostname == "m0.eicchannel.com") {
        window.location.href =
          "http://m0.eicchannel.com/special/expo_science_engineering_202011_m/#teacher";
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.type = this.$route.query.type;
    this.getActivityInfo();
    this.getCityList();
    this.userIsLogin();
    this.getCurCity();
  },
  watch: {
    expoId(newVal) {
      if (newVal) {
        this.getAdv();
        this.getAdviser();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.examList {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: url(~@/assets/images/schoollist_head.png) no-repeat;
  background-size: 100% auto;
  .sub-box {
    padding: 0.3rem 0.3rem 0;
    min-height: 100%;
    .btn-return {
      display: block;
      width: 0.98rem;
      height: 0.37rem;
      line-height: 0.36rem;
      text-align: center;
      background-color: #5b656c;
      color: #fff;
      font-weight: 400;
      font-size: 0.22rem;
      border-radius: 3rem;
      margin-bottom: 0.3rem;
    }
    .examlist-body {
      background: #cee6fb;
      border-radius: 0.2rem;
      padding: 0.23rem 0.2rem;
      margin-bottom: 1.2rem;
      .ads {
        border-radius: 0.2rem;
        overflow: hidden;
        //border: 0.06rem solid #6493ff;
        height: 1.4rem;
        margin-bottom: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .list-tit {
        font-size: 0.38rem;
        font-family: FZLanTingYuanS-DB1-GB;
        font-weight: 400;
        color: #333c3f;
        line-height: 0.8rem;
        text-align: center;
      }

      .examlist-con {
        border-radius: 0.2rem;
        overflow: hidden;
        position: relative;
        background: #d5eafc;
        .countrylist {
          background: #465da5;
          padding: 0.2rem 0.19rem;
          display: inline-block;
          align-content: center;
          justify-content: center;
          min-width: 6.66rem;
          text-align: center;
          li {
            display: inline-block;
            font-size: 0.24rem;
            font-family: FZLanTingYuanS-DB1-GB;
            font-weight: 400;
            color: #fff;
            margin: 0.02rem 0.2rem;
          }
          .active {
            color: #f9e068;
            border-bottom: 0.05rem solid #f9e068;
          }
        }

        .examList-hid {
          background: #fff;
          padding: 0.2rem 0.2rem 0.1rem 0.3rem;
          position: relative;
          min-height: 5rem;
          //margin-top: 2.6rem;
          dl {
            padding: 0.35rem 0;
            border-bottom: 1px solid #ebf0f9;
            dt {
              width: 1.5rem;
              float: left;
              margin: 0 0.4rem 0.1rem 0;
              img {
                display: block;
                background: #f0f3f7;
                border-radius: 0.1rem;
                overflow: hidden;
              }
            }
            dd {
              width: 4.08rem;
              float: left;
              position: relative;
              h5 {
                border-left: 0.03rem solid #ff6368;
                padding-left: 0.09rem;
                margin-left: -0.1rem;
                font-size: 0.28rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333c3f;
              }
              b {
                padding-bottom: 0.06rem;
                padding-right: 0.4rem;
                font-size: 0.24rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333c3f;
                border-bottom: 1px solid #ebf0f9;
              }
              p {
                font-size: 0.22rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #5e5e5e;
                line-height: 0.28rem;
                margin-top: 0.18rem;
              }
            }
          }
          .loading {
            width: 2rem;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }

      .btn-teacher-yy {
        width: 2.8rem;
        height: 0.85rem;
        line-height: 0.85rem;
        text-align: center;
        background-color: #ff6368;
        border-radius: 2rem;
        box-shadow: 0 0.05rem 0 0 #d66569;
        color: #fff;
        font-weight: 900;
        position: fixed;
        bottom: 10%;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 99;
      }
    }
  }

  .btn-teacher-yy {
    width: 3.82rem;
    height: 1rem;
    border-radius: 0.5rem;
    background: #f15d57;
    color: #fff;
    font-size: 0.44rem;
    line-height: 1rem;
    position: fixed;
    bottom: 15%;
    left: 50%;
    margin-left: -1.91rem;
    text-align: center;
    z-index: 99;
  }

  .project-tc-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
  .project-tc {
    width: 6.1rem;
    height: 4.3rem;
    background: #fff;
    border-radius: 0.12rem;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    padding: 0 0.6rem;
  }
  .project-tc h3 {
    font-size: 18px;
    font-weight: 900;
  }
  .project-tc span {
    width: 0.4rem;
    height: 0.4rem;
    background: url(~@/assets/images/pop_close_btn.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
    font-size: 0;
    cursor: pointer;
  }
  .project-tc button {
    display: block;
    border: 0;
    width: 2.54rem;
    height: 0.52rem;
    line-height: 0.52rem;
    text-align: center;
    border-radius: 0.26rem;
    font-size: 0.24rem;
    font-weight: 700;
    color: #fff;
    background: #0475df;
    margin: 0.2rem auto 0.4rem;
  }
  .project-tc ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 0.28rem;
    margin-top: 0.54rem;
  }
  .project-tc ul li {
    width: 1.5rem;
    height: 0.6rem;
    line-height: 0.6rem;
    background: #f2f5f7;
    margin-bottom: 0.25rem;
    border-radius: 0.05rem;
    cursor: pointer;
    color: #474d60;
  }
  .project-tc ul li.active {
    background: #42b9c8;
    color: #fff;
  }
  .project-tc p {
    font-size: 0.2rem;
    color: #7f838f;
    padding: 0.2rem 0;
  }
}
</style>
